import React from "react";
import PropTypes from 'prop-types'
import { BgButton } from "../../pages/Theme";

const CancelButton = ({onClick, title, style, textStyle, ...props}) => {
    return(
        <BgButton 
            className={`flex flex-row cursor-pointer rounded-lg border-2 p-3 h-1 px-3 
                        items-center justify-center w-flex filter drop-shadow-sm ${style}`} 
            onClick={onClick}
        >
            <p className={`${"font-semibold pt-0.5 text-xs whitespace-nowrap"} ${textStyle}`}>{title}</p>
        </BgButton>   
    )
}
CancelButton.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
}

export default CancelButton
